import React from "react";
import { Button } from "@/components/ui/button";
import { useLanguage } from "@/hooks/use-language";
import { useSidebar } from "@/hooks/use-sidebar";

export function LanguageToggle() {
  const { language, setLanguage } = useLanguage();
  const { state } = useSidebar();

  const toggleLanguage = () => {
    setLanguage(language === "no" ? "en" : "no");
  };

  const isCollapsed = state === "collapsed";

  return (
    <Button
      variant="ghost"
      size="sm"
      onClick={toggleLanguage}
      className={`w-full ${isCollapsed ? "flex-col px-2 py-1 h-auto" : "justify-start"}`}
    >
      <span className={`text-lg ${isCollapsed ? "mb-1" : "mr-2"}`}>
        {language === "no" ? "🇳🇴" : "🇬🇧"}
      </span>
      <span className="text-sm font-medium">
        {language === "no" ? "NO" : "EN"}
      </span>
    </Button>
  );
}
